import { alpha } from "@mantine/core";
import { Box } from "../../../box";
import { Text } from "../../../text";
import { Skeleton } from "../../../skeleton";
import { useTheme } from "../../../../hooks";

/**
 * Displays a sticky date badge with semi-transparent background at the top of each day's messages.
 * @param {string} props.text - The date text to display in the badge.
 * @returns {JSX.Element} The DayBadge component.
 */
const DayBadge = ({ text }: { text: string }) => {
    const theme = useTheme();
    return (
        <Box pos="sticky" top={0} bdrs="xl" bg={alpha(theme.black, 0.6)} p="sm" style={{ zIndex: 1 }}>
            <Text size="xs" c="white" data-testid="day-badge">
                {text}
            </Text>
        </Box>
    );
};
/**
 * Loading skeleton placeholder for the DayBadge component.
 * @returns {JSX.Element} The DayBadgeSkeleton component.
 */
const DayBadgeSkeleton = () => {
    return <Skeleton height={30} width={180} />;
};
DayBadge.Skeleton = DayBadgeSkeleton;

export { DayBadge };
